import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useViewAs } from '../context/ViewAsContext';
import Dashboard from './Dashboard';
import PatientDashboard from './PatientDashboard';

const DashboardRouter = () => {
  const { user } = useAuth();
  const { getEffectiveRole } = useViewAs();
  
  const effectiveRole = getEffectiveRole(user?.role);
  
  // Patient gets their own dedicated dashboard
  if (effectiveRole === 'patient') {
    return <PatientDashboard />;
  }
  
  // All other roles use the standard Dashboard with role-specific rendering
  return <Dashboard />;
};

export default DashboardRouter;
